
/*
Defines the custom element <ravel-button>
*/

import { RavelButton } from './src/RavelButton.js';

customElements.define('ravel-button', RavelButton);
